<template>
    <div class="view view--support">
        <support />
    </div>
</template>

<script>
    import support from '../components/Support.vue';

    export default {
        components: {
            support
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/Support.vue